import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {OnboardingPage} from "./page/onboarding-page/onboarding.page";
import {AppIntroComponent} from "./components/app-intro/app-intro.component";
import {UploadContractComponent} from "./components/upload-contract/upload-contract.component";
import {QuestionnaireComponent} from "./components/questionnaire/questionnaire.component";
import {FileUploadModule} from "primeng/fileupload";
import {CarouselModule} from "primeng/carousel";
import {DropdownModule} from "primeng/dropdown";
import {DialogModule} from "primeng/dialog";
import {SelectButtonModule} from "primeng/selectbutton";
import {AutoCompleteModule} from "primeng/autocomplete";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {TableModule} from "primeng/table";
import {DataViewModule} from "primeng/dataview";
import {TreeSelectModule} from "primeng/treeselect";
import {ToastModule} from "primeng/toast";
import {AutoCompleteFormFieldComponent} from "./components/auto-complete-form-field/auto-complete-form-field.component";
import {CrossModule} from "../cross/cross.module";
import {IconDisplayPipe} from "./pipes/icon-display.pipe";
import {DynamicClassPipe} from "./pipes/dynamic-class.pipe";
import {QRCodeModule} from "angularx-qrcode";
import {ConfirmDialogModule} from "primeng/confirmdialog";


@NgModule({
  declarations: [
    OnboardingPage,
    AppIntroComponent,
    UploadContractComponent,
    QuestionnaireComponent,
    AutoCompleteFormFieldComponent,
    AutoCompleteFormFieldComponent,
  ],
    exports: [
        OnboardingPage,
        AutoCompleteFormFieldComponent,
        AutoCompleteFormFieldComponent,
        UploadContractComponent,
    ],
    imports: [
        CoreModule,
        FileUploadModule,
        CarouselModule,
        DropdownModule,
        DialogModule,
        SelectButtonModule,
        AutoCompleteModule,
        OverlayPanelModule,
        TableModule,
        DataViewModule,
        TreeSelectModule,
        ToastModule,
        CrossModule,

        ToastModule,
        IconDisplayPipe,
        DynamicClassPipe,
        QRCodeModule,
        ConfirmDialogModule
    ]
})
export class ObModule { }
